<div class="breadcrumb">
    <ng-container *ngFor="let route of routes;let i=index;">
        <span (click)="navigateTo(route.routeTo,i)" class="breadcrumb-text" [ngClass]="{'active':i==routes.length-1}"> 
            {{route.label}}
        </span>
        <span class="arrow" *ngIf="i < routes.length-1"> > </span>
    </ng-container>
</div>